// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VelocitySimulationRightMenu__wrapper___KS8N0 > .VelocitySimulationRightMenu__rightMenuChoiceGroup___PBESf {
    display: flex;
    flex-grow: 1;
    margin-bottom: 1.6rem;
}

.VelocitySimulationRightMenu__treeInput___pR2LT input {
    width: 5rem;
    min-width: 5rem;
    max-width: 10rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.VelocitySimulationRightMenu__wrapper___KS8N0 .ChoiceGroup-Divider {
    width: 0;
    min-width: 0;
}

.VelocitySimulationRightMenu__layersMenuFields___jI_Rs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    margin-top: 1rem;
}

.VelocitySimulationRightMenu__modelMenuSelect___VmLwk {
    width: 29.6rem;
}

.VelocitySimulationRightMenu__textField___cZdDa {
    padding-bottom: 0.8rem;
}

.VelocitySimulationRightMenu__modelSelect___lSNVY {
    margin-bottom: 1.6rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.VelocitySimulationRightMenu__wrapper___KS8N0 .SelectDropdown-LabelForEmptyItems {
    font-size: 1.2rem;
}

.VelocitySimulationRightMenu__layersMenuTextFields___iBcoS {
    width: 13.8rem;
}

.VelocitySimulationRightMenu__layersContainer___ws4LX {
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
    padding: 0.7rem;

    background-color: var(--color-bg-stripe);
    border-radius: 0.4rem;
}

.VelocitySimulationRightMenu__layersWrapper___K_v39 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.VelocitySimulationRightMenu__layersTextPaddingBottom____MkUB {
    padding-right: 1.2rem;
    padding-bottom: 0.4rem;
}

.VelocitySimulationRightMenu__modelMenuResultsGrid___v15Fg {
    display: grid;
    grid-gap: 1rem;
    grid-template-rows: auto auto auto;
    margin-top: 1.6rem;
}

.VelocitySimulationRightMenu__modelMenuResultsGridRow___a3qyt {
    display: grid;
    grid-template-columns: auto auto;
}

.VelocitySimulationRightMenu__modelMenuResultsGridItem___itlaA {
    display: grid;
    grid-template-columns: 6rem 9rem;
    justify-content: flex-start;
}

.VelocitySimulationRightMenu__selectLayerItemLayerBorderTopContainer___PI1K7 {
    display: grid;
    grid-template-columns: 49% 49%;
    align-items: center;
    justify-content: space-between;
}

.VelocitySimulationRightMenu__selectLayerItemLayerBorderContainer___Etfij {
    display: flex;
    flex-direction: column;
    margin-right: 1rem;
}

.VelocitySimulationRightMenu__textPaddingBottom___CktfQ {
    padding-bottom: 0.8rem;
}

.VelocitySimulationRightMenu__textPaddingRight___MLzyZ {
    padding-right: 0.4rem;
}

.VelocitySimulationRightMenu__textPaddingTop___BjwdM {
    padding-top: 0.4rem;
}

.VelocitySimulationRightMenu__selectLayerItemItemBox___YXpDt {
    margin-top: 1rem;
    padding: 0.7rem;
    background-color: var(--color-bg-stripe);
    border-radius: 0.4rem;
}

.VelocitySimulationRightMenu__selectLayerItemLayerMarkerStats___r2BYh {
    display: grid;
    grid-template-columns: 40% auto;
    align-items: center;
    justify-content: flex-start;

    padding-top: 0.4rem;
}

.VelocitySimulationRightMenu__layersMenuReductionLevelFields___V9sZj {
    display: grid;
    grid-template-columns: 50% 50%;
}

.VelocitySimulationRightMenu__selectLayerItemItemBoxAlert___PLXYR {
    border: 0.1rem solid var(--color-bg-alert);
    border-radius: 0.4rem;
}

.VelocitySimulationRightMenu__selectLayerItemIconColor___lPRnX {
    color: var(--color-control-typo-placeholder);
}

.VelocitySimulationRightMenu__collapsedItem___qcv_4 {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.VelocitySimulationRightMenu__collapsedItemPosition___dVGR0 {
    margin-bottom: 0.4rem;
}

.VelocitySimulationRightMenu__iconAlerts___HeWkE {
    margin-left: 1.2rem;
}

.VelocitySimulationRightMenu__collapsedItemWrapper___jSioN {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.VelocitySimulationRightMenu__entityName___LUIfI {
    padding-bottom: 1.6rem;
}

.VelocitySimulationRightMenu__entityNameText___Ohyse {
    margin-bottom: 0.8rem;
}

.VelocitySimulationRightMenu__modelMenuResultsGridRowText___mte6w {
    margin-right: 0.8rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/VelocitySimulation/VelocitySimulationRightMenu/VelocitySimulationRightMenu.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,uEAAuE;AACvE;IACI,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;;IAE3B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA,uEAAuE;AACvE;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;;IAEf,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,2BAA2B;;IAE3B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".wrapper > .rightMenuChoiceGroup {\n    display: flex;\n    flex-grow: 1;\n    margin-bottom: 1.6rem;\n}\n\n.treeInput input {\n    width: 5rem;\n    min-width: 5rem;\n    max-width: 10rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.wrapper :global(.ChoiceGroup-Divider) {\n    width: 0;\n    min-width: 0;\n}\n\n.layersMenuFields {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n\n    margin-top: 1rem;\n}\n\n.modelMenuSelect {\n    width: 29.6rem;\n}\n\n.textField {\n    padding-bottom: 0.8rem;\n}\n\n.modelSelect {\n    margin-bottom: 1.6rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.wrapper :global(.SelectDropdown-LabelForEmptyItems) {\n    font-size: 1.2rem;\n}\n\n.layersMenuTextFields {\n    width: 13.8rem;\n}\n\n.layersContainer {\n    margin-top: 1.2rem;\n    margin-bottom: 1.2rem;\n    padding: 0.7rem;\n\n    background-color: var(--color-bg-stripe);\n    border-radius: 0.4rem;\n}\n\n.layersWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.layersTextPaddingBottom {\n    padding-right: 1.2rem;\n    padding-bottom: 0.4rem;\n}\n\n.modelMenuResultsGrid {\n    display: grid;\n    grid-gap: 1rem;\n    grid-template-rows: auto auto auto;\n    margin-top: 1.6rem;\n}\n\n.modelMenuResultsGridRow {\n    display: grid;\n    grid-template-columns: auto auto;\n}\n\n.modelMenuResultsGridItem {\n    display: grid;\n    grid-template-columns: 6rem 9rem;\n    justify-content: flex-start;\n}\n\n.selectLayerItemLayerBorderTopContainer {\n    display: grid;\n    grid-template-columns: 49% 49%;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.selectLayerItemLayerBorderContainer {\n    display: flex;\n    flex-direction: column;\n    margin-right: 1rem;\n}\n\n.textPaddingBottom {\n    padding-bottom: 0.8rem;\n}\n\n.textPaddingRight {\n    padding-right: 0.4rem;\n}\n\n.textPaddingTop {\n    padding-top: 0.4rem;\n}\n\n.selectLayerItemItemBox {\n    margin-top: 1rem;\n    padding: 0.7rem;\n    background-color: var(--color-bg-stripe);\n    border-radius: 0.4rem;\n}\n\n.selectLayerItemLayerMarkerStats {\n    display: grid;\n    grid-template-columns: 40% auto;\n    align-items: center;\n    justify-content: flex-start;\n\n    padding-top: 0.4rem;\n}\n\n.layersMenuReductionLevelFields {\n    display: grid;\n    grid-template-columns: 50% 50%;\n}\n\n.selectLayerItemItemBoxAlert {\n    border: 0.1rem solid var(--color-bg-alert);\n    border-radius: 0.4rem;\n}\n\n.selectLayerItemIconColor {\n    color: var(--color-control-typo-placeholder);\n}\n\n.collapsedItem {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.collapsedItemPosition {\n    margin-bottom: 0.4rem;\n}\n\n.iconAlerts {\n    margin-left: 1.2rem;\n}\n\n.collapsedItemWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.entityName {\n    padding-bottom: 1.6rem;\n}\n\n.entityNameText {\n    margin-bottom: 0.8rem;\n}\n\n.modelMenuResultsGridRowText {\n    margin-right: 0.8rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `VelocitySimulationRightMenu__wrapper___KS8N0`,
	"rightMenuChoiceGroup": `VelocitySimulationRightMenu__rightMenuChoiceGroup___PBESf`,
	"treeInput": `VelocitySimulationRightMenu__treeInput___pR2LT`,
	"layersMenuFields": `VelocitySimulationRightMenu__layersMenuFields___jI_Rs`,
	"modelMenuSelect": `VelocitySimulationRightMenu__modelMenuSelect___VmLwk`,
	"textField": `VelocitySimulationRightMenu__textField___cZdDa`,
	"modelSelect": `VelocitySimulationRightMenu__modelSelect___lSNVY`,
	"layersMenuTextFields": `VelocitySimulationRightMenu__layersMenuTextFields___iBcoS`,
	"layersContainer": `VelocitySimulationRightMenu__layersContainer___ws4LX`,
	"layersWrapper": `VelocitySimulationRightMenu__layersWrapper___K_v39`,
	"layersTextPaddingBottom": `VelocitySimulationRightMenu__layersTextPaddingBottom____MkUB`,
	"modelMenuResultsGrid": `VelocitySimulationRightMenu__modelMenuResultsGrid___v15Fg`,
	"modelMenuResultsGridRow": `VelocitySimulationRightMenu__modelMenuResultsGridRow___a3qyt`,
	"modelMenuResultsGridItem": `VelocitySimulationRightMenu__modelMenuResultsGridItem___itlaA`,
	"selectLayerItemLayerBorderTopContainer": `VelocitySimulationRightMenu__selectLayerItemLayerBorderTopContainer___PI1K7`,
	"selectLayerItemLayerBorderContainer": `VelocitySimulationRightMenu__selectLayerItemLayerBorderContainer___Etfij`,
	"textPaddingBottom": `VelocitySimulationRightMenu__textPaddingBottom___CktfQ`,
	"textPaddingRight": `VelocitySimulationRightMenu__textPaddingRight___MLzyZ`,
	"textPaddingTop": `VelocitySimulationRightMenu__textPaddingTop___BjwdM`,
	"selectLayerItemItemBox": `VelocitySimulationRightMenu__selectLayerItemItemBox___YXpDt`,
	"selectLayerItemLayerMarkerStats": `VelocitySimulationRightMenu__selectLayerItemLayerMarkerStats___r2BYh`,
	"layersMenuReductionLevelFields": `VelocitySimulationRightMenu__layersMenuReductionLevelFields___V9sZj`,
	"selectLayerItemItemBoxAlert": `VelocitySimulationRightMenu__selectLayerItemItemBoxAlert___PLXYR`,
	"selectLayerItemIconColor": `VelocitySimulationRightMenu__selectLayerItemIconColor___lPRnX`,
	"collapsedItem": `VelocitySimulationRightMenu__collapsedItem___qcv_4`,
	"collapsedItemPosition": `VelocitySimulationRightMenu__collapsedItemPosition___dVGR0`,
	"iconAlerts": `VelocitySimulationRightMenu__iconAlerts___HeWkE`,
	"collapsedItemWrapper": `VelocitySimulationRightMenu__collapsedItemWrapper___jSioN`,
	"entityName": `VelocitySimulationRightMenu__entityName___LUIfI`,
	"entityNameText": `VelocitySimulationRightMenu__entityNameText___Ohyse`,
	"modelMenuResultsGridRowText": `VelocitySimulationRightMenu__modelMenuResultsGridRowText___mte6w`
};
export default ___CSS_LOADER_EXPORT___;
